import { observer } from 'mobx-react-lite';
import * as React from 'react';
import InfobarShowHideDetailsPart from './InfobarShowHideDetailsPart';
import { InfobarShowHideDetailsPartProps } from './InfoBarComponentProps';
import { InfoBarMessageWithShowDetailsActionProps } from './InfoBarComponentProps';

export interface InfoBarShowDetailsActionState {
    isShowingDetails: boolean;
}

export default observer(function InfoBarMessageWithShowDetailsAction(
    props: InfoBarMessageWithShowDetailsActionProps
) {
    const [isShowingDetails, setIsShowingDetails] = React.useState<boolean>(false);
    const toggleShowingDetails = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        setIsShowingDetails(!isShowingDetails);
    };
    const { children, ...otherProps } = props;
    const infobarShowHideDetailsPartProps: InfobarShowHideDetailsPartProps = {
        ...otherProps,
        clickHandler: toggleShowingDetails,
        isShowingDetails: isShowingDetails,
    };
    return <InfobarShowHideDetailsPart {...infobarShowHideDetailsPartProps} />;
});
